var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lesson)?_c('div',{staticClass:"home-lesson-slide book-cover",class:_vm.lesson.is_month ? 'month' : ''},[_c('router-link',{attrs:{"to":_vm.to}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.img}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }